.container {
    padding: 16px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.done {
    font-size: var(--font-small);
    line-height: 17px;
    color: var(--onboarding-help);
    padding-top: 4px;
}

.party {
    margin-right: 8px;
    font-size: 18px;
}

.arrow {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    margin-left: 8px;
    padding: 0;
    border-radius: 3px;
}

.arrow :global(svg) {
    transition: transform 120ms ease;
}

.arrow:hover :global(svg),
.arrow:focus-within :global(svg) {
    transform: scale(1.15);
}

.arrow:active :global(svg) {
    transform: scale(0.95);
}
